import t from"react";var n=function(n){var o=n.children,a=n.onClick;return t.createElement("button",{className:"vchasno-ui-snackbar-action-button",type:"button",onClick:a},o)};export{n as default};
//# sourceMappingURL=ActionButton.js.map
